<ng-container *realUser="user() as user; else anonymous">
  <button mat-ripple class="btn btn-flat btn-icon text-emerald-400 dark:text-emerald-400"
          [matMenuTriggerFor]="WidgetMenu">
    <fa-icon [icon]="icons.faCircleUser"></fa-icon>
  </button>
  <mat-menu #WidgetMenu="matMenu">
    <a mat-ripple
       class="grid gap-2 px-4 py-2 h-auto! leading-normal! hover:bg-slate-500/10 focus:bg-slate-500/10">
      <div>{{user.name}}</div>
      <div>{{user.email}}</div>
    </a>
    <mat-divider></mat-divider>
    <div class="grid place-content-center py-4">
      <button class="btn btn-outlined" mat-ripple
              (click)="signOut($event)">
        Sign Out
      </button>
    </div>
  </mat-menu>
</ng-container>

<ng-template #anonymous>
  <button mat-ripple class="btn btn-outlined btn-shadow"
          (click)="signIn()">
    Log In
  </button>
</ng-template>
